import useAnnouncementEditRouteConfig from "../../../routes/configs/announcements/AnnouncementEditRouteConfig";
import useAnnouncementCreateRouteConfig from "../../../routes/configs/announcements/AnnouncementCreateRouteConfig";
import DataTableConfig from "../main/config/dataTable/DataTableConfig";
import useBasicColumnConfig from "../main/config/column/default/BasicColumnConfig";
import useTimestampColumnConfig from "../main/config/column/default/TimestampColumnConfig";
import useEditRowActionConfig from "../main/config/rowAction/default/EditRowActionConfig";
import useDeleteRowActionConfig from "../main/config/rowAction/default/DeleteRowActionConfig";
import useCreateHeaderActionConfig from "../main/config/headerAction/default/CreateHeaderActionConfig";
import DataTable, { useDataTable } from "../main/DataTable";

function AnnouncementsDataTable() {
  //Create the datatable config
  const config = new DataTableConfig("announcements");

  //Set the datatable fetch info
  config.setFetchRequest("announcements");

  //Set the datatable order by
  config.setOrderBy("title");
  config.setOrderDirection("asc");

  //set the datatable columns
  config.setColumns([
    useBasicColumnConfig("title").setLockActive(true),
    useBasicColumnConfig("description").setDataStyle(() => ({
      maxWidth: "300px",
    })),
    useBasicColumnConfig("active_from"),
    useBasicColumnConfig("active_until"),
    useTimestampColumnConfig("created_at"),
    useTimestampColumnConfig("updated_at"),
  ]);

  //Set the datatable row actions
  config.setRowActions([
    useEditRowActionConfig("announcement", useAnnouncementEditRouteConfig()),
    useDeleteRowActionConfig("announcement"),
  ]);

  //Set the datatable header actions
  config.setHeaderActions([
    useCreateHeaderActionConfig(
      "announcement",
      useAnnouncementCreateRouteConfig(),
    ),
  ]);

  //Create the datatable object
  const dataTable = useDataTable(config);

  return <DataTable controller={dataTable} />;
}

export default AnnouncementsDataTable;
